const Config = {
    TOKEN: "token",
    CODE: "code",
    NAME: "name",
};
export default Config;
  